export default __webpack_public_path__ + "static/media/search.6f1d4541.svg";